const linkTransactionSchema = require("./linkTransaction");
const wishlistTransactionSchema = require("./wishlistTransaction");
const linkShareSchema = require("./linkShare");
const bankTransactionSchema = require("./bankTransaction");

module.exports = {
  linkTransaction: linkTransactionSchema,
  wishlistTransaction: wishlistTransactionSchema,
  linkShare: linkShareSchema,
  bankTransaction: bankTransactionSchema,
};